export default [
  {
    path: '/trips/',
    name: 'welcome',
    component: () => import('./pages/Welcome.vue')
  },
  {
    path: '/privacy-statement',
    name: 'privacy-statement',
    component: () => import('./pages/PrivacyStatement.vue')
  },
  {
    path: '/trips/:dashboardId',
    component: () => import('./pages/Trip.vue'),
    children: [
      {
        path: 'edit-profile',
        name: 'edit-profile',
        component: () => import('./pages/Trip/EditProfile.vue')
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('./pages/Trip/Dashboard.vue')
      },
      {
        path: 'todo',
        component: () => import('./pages/Trip/ToDo.vue'),
        children: [
          {
            path: 'completed',
            name: 'to-do.completed',
            component: () => import('./pages/Trip/to-do/ToDoComplete.vue')
          },
          {
            path: '',
            name: 'to-do.incomplete',
            component: () => import('./pages/Trip/to-do/ToDoIncomplete.vue')
          }
        ]
      },
      {
        path: 'trip-team',
        name: 'trip-team',
        component: () => import('./pages/Trip/TripTeam.vue')
      },
      {
        path: 'travel-information',
        name: 'travel-information',
        component: () => import('./pages/Trip/TravelInfo.vue')
      },
      {
        path: 'flight-information',
        name: 'flight-information',
        component: () => import('./pages/Trip/FlightInfo.vue')
      },
      {
        path: 'packing-information',
        name: 'packing-information',
        component: () => import('./pages/Trip/PackingInformation.vue')
      },
      {
        path: 'reservation',
        name: 'reservation',
        component: () => import('./pages/Trip/Reservation.vue')
      },
      {
        path: 'calendar',
        name: 'calendar',
        component: () => import('./pages/Trip/Calendar.vue')
      },
      {
        path: 'invoices',
        component: () => import('./pages/Trip/Invoices.vue'),
        children: [
          {
            path: 'paid',
            name: 'invoices',
            component: () => import('./pages/Trip/invoices/Invoices.vue')
          },
          {
            path: 'payments',
            name: 'payments',
            component: () => import('./pages/Trip/invoices/Payments.vue')
          },
          {
            path: 'pay',
            name: 'invoices.make-payment',
            component: () => import('./pages/Trip/invoices/MakePayment.vue'),
            children: [
              // MANUAL
              {
                path: ':invoiceId/check',
                name: 'invoices.make-payment.check',
                component: () => import('./pages/PaymentTerminal/gateways/Check.vue')
              },
              {
                path: ':invoiceId/wire',
                name: 'invoices.make-payment.wire',
                component: () => import('./pages/PaymentTerminal/gateways/Wire.vue')
              },

              // GATEWAYS
              {
                path: ':invoiceId/credit-card/anet',
                name: 'invoices.make-payment.cc-anet',
                component: () => import('./pages/PaymentTerminal/gateways/CCAnet.vue')
              },
              {
                path: ':invoiceId/credit-card/cs',
                name: 'invoices.make-payment.cc-cs',
                component: () => import('./pages/PaymentTerminal/gateways/CCCyberSource.vue')
              },
              {
                path: ':invoiceId/echeck/anet',
                name: 'invoices.make-payment.echeck-anet',
                component: () => import('./pages/PaymentTerminal/gateways/eCheckAnet.vue')
              },
              {
                path: ':invoiceId/echeck/cs',
                name: 'invoices.make-payment.echeck-cs',
                component: () => import('./pages/PaymentTerminal/gateways/eCheckCybersource.vue')
              }
            ]
          }
        ]
      },
      {
        path: 'uploaded-documents',
        name: 'uploaded-documents',
        component: () => import('./pages/Trip/YourDocuments.vue')
      },
      {
        path: 'personal-information-forms',
        name: 'pifs',
        component: () => import('./pages/Trip/PersonalInformationForms.vue'),
        children: [
          {
            path: ':pifId',
            name: 'pifs.pif',
            component: () => import('./forms/PersonalInformationForm/PersonalInformationForm.vue')
          }
        ]
      },
      {
        path: 'final-documents',
        name: 'final-documents',
        component: () => import('./pages/Trip/FinalDocuments.vue')
      }
    ]
  },
  {
    path: '/payment-terminal',
    name: 'payment-terminal',
    component: () => import('./pages/PaymentTerminal.vue'),
    children: [
      // MANUAL
      {
        path: 'check',
        name: 'payment-terminal.check',
        component: () => import('./pages/PaymentTerminal/gateways/Check.vue')
      },
      {
        path: 'wire',
        name: 'payment-terminal.wire',
        component: () => import('./pages/PaymentTerminal/gateways/Wire.vue')
      },

      // GATEWAYS
      {
        path: 'credit-card/anet/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal.cc-anet',
        component: () => import('./pages/PaymentTerminal/gateways/CCAnet.vue')
      },
      {
        path: 'credit-card/cs/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal.cc-cs',
        component: () => import('./pages/PaymentTerminal/gateways/CCCyberSource.vue')
      },
      {
        path: 'echeck/anet/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal.echeck-anet',
        component: () => import('./pages/PaymentTerminal/gateways/eCheckAnet.vue')
      },
      {
        path: 'echeck/cs/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal.echeck-cs',
        component: () => import('./pages/PaymentTerminal/gateways/eCheckCybersource.vue')
      }
    ]
  },
  {
    path: '/pay',
    name: 'payment-terminal-unbranded',
    component: () => import('./pages/PaymentTerminal.vue'),
    children: [
      // MANUAL
      {
        path: 'check',
        name: 'payment-terminal-unbranded.check',
        component: () => import('./pages/PaymentTerminal/gateways/Check.vue')
      },
      {
        path: 'wire',
        name: 'payment-terminal-unbranded.wire',
        component: () => import('./pages/PaymentTerminal/gateways/Wire.vue')
      },

      // GATEWAYS
      {
        path: 'credit-card/anet/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal-unbranded.cc-anet',
        component: () => import('./pages/PaymentTerminal/gateways/CCAnet.vue')
      },
      {
        path: 'credit-card/cs/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal-unbranded.cc-cs',
        component: () => import('./pages/PaymentTerminal/gateways/CCCyberSource.vue')
      },
      {
        path: 'echeck/anet/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal-unbranded.echeck-anet',
        component: () => import('./pages/PaymentTerminal/gateways/eCheckAnet.vue')
      },
      {
        path: 'echeck/cs/:invoiceHash?/:invoiceHashId?',
        name: 'payment-terminal-unbranded.echeck-cs',
        component: () => import('./pages/PaymentTerminal/gateways/eCheckCybersource.vue')
      }
    ]
  }
]
